import { render, staticRenderFns } from "./navigation-json-seo-schema.vue?vue&type=template&id=29c8dcb2&lang=pug&"
import script from "./navigation-json-seo-schema.vue?vue&type=script&lang=js&"
export * from "./navigation-json-seo-schema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "navigation-json-seo-schema.vue"
export default component.exports